/* WebComponentAccordionGallery template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { AccordionGalleryComponent } from '../cwc-accordion-gallery';

/**
 * Definition of  parameters that the template needs to work.
 */
interface AccordionGalleryTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: AccordionGalleryComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const AccordionGalleryTemplate: FunctionalComponent<AccordionGalleryTemplateProps> = () => (
  <Host>
    <backgrounds>
      <slot name={'slide1_background'} />
      <slot name={'slide2_background'} />
      <slot name={'slide3_background'} />
      <slot name={'slide4_background'} />
      <slot name={'slide5_background'} />
      <slot name={'slide6_background'} />
      <slot name={'slide7_background'} />
      <slot name={'slide8_background'} />
      <slot name={'slide9_background'} />
      <slot name={'slide10_background'} />
    </backgrounds>

    <slides>
      <slot />
    </slides>
  </Host>
);

export default AccordionGalleryTemplate;
